import React from "react";
import { usePage } from "@inertiajs/react";
import styled from "styled-components";
import {
  LandingLanguageProvider,
  useLandingLanguage,
} from "../../../contexts/landing-language";
import Header from "../home/Header";
import Footer from "../home/Footer";
import StrapiRichText from "../../../components/StrapiRichText";

const PageSection = styled.section`
  background: #fff;
  padding: 140px 24px 100px;
`;

const Container = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const PageTitle = styled.h1`
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
`;

const LastUpdated = styled.p`
  font-size: 14px;
  color: #999;
  margin-bottom: 48px;
`;

const Section = styled.div`
  margin-bottom: 36px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 12px;
  }

  p {
    font-size: 15px;
    line-height: 1.8;
    color: #555;
  }
`;

const PrivacyPolicyContent = () => {
  const { privacy_policy } = usePage().props;
  const { t } = useLandingLanguage();
  const fallback = t.privacyPolicy;

  const title = privacy_policy?.title || fallback.title;
  const lastUpdated = privacy_policy?.last_updated_at || fallback.lastUpdated;
  const sections = privacy_policy?.sections?.length
    ? privacy_policy.sections
    : fallback.sections.map((s) => ({
        title: s.heading,
        content: null,
        _body: s.body,
      }));

  return (
    <PageSection>
      <Container>
        <PageTitle>{title}</PageTitle>
        <LastUpdated>{lastUpdated}</LastUpdated>
        {sections.map((section, i) => (
          <Section key={i}>
            <h2>{section.title}</h2>
            {section.content ? (
              <StrapiRichText content={section.content} />
            ) : (
              <p>{section._body}</p>
            )}
          </Section>
        ))}
      </Container>
    </PageSection>
  );
};

const PrivacyPolicy = () => {
  return (
    <LandingLanguageProvider>
      {/* Title and the noindex are server-rendered from Hebe::SeoPresenter#legal
          so the directive does not depend on JavaScript running. */}
      <React.Fragment>
        <Header forceScrolled />
        <PrivacyPolicyContent />
        <Footer />
      </React.Fragment>
    </LandingLanguageProvider>
  );
};

export default PrivacyPolicy;
